<template>
  <div class="test-users">
    <v-text-field
      v-model="search"
      outlined
      append-icon="$sl-search"
      :label="$t('application.search-label')"
      class="mt-5"
      hide-details
    />
    
    <div class="d-flex align-center">
      <v-select
        :label="$t('company.roles')"
        v-model="role"
        @change="updateUsers"
        :items="roles"
        item-value="key"
        item-text="value"
        class="mr-1 pill-select"
        :menu-props="{
          contentClass: 'pill-select-menu',
          bottom: true,
          offsetY: true
        }"
        hide-details
      />
      <v-select
        :label="$t('fields.company')"
        v-model="company"
        @change="updateUsers"
        :items="companies"
        item-value="key"
        item-text="value"
        class="ml-1 pill-select"
        :menu-props="{
          contentClass: 'pill-select-menu',
          bottom: true,
          offsetY: true
        }"
        hide-details
      />
    </div>

    <div class="test-users__list">
      <button
        v-for="(fake, idx) in filteredFakes"
        :key="idx"
        type="button"
        class="login-link login-link--border"
        @click="loginAs(`${fake.personalNumber}`)"
      > 
        <div class="d-flex align-center">
          <small>{{ fake.fullName }} </small>
          <br />
          <small>{{ displayText(fake) }}</small>
        </div>
  
        <v-icon>$sl-arrow-right</v-icon>
      </button>
    </div>

    <div class="my-2 border"></div>

    <button class="login-link" type="button" @click="loginAs('200711042382')">
      <small>{{ $t('dev-buttons.underage') }}</small>
      <v-icon>$sl-arrow-right</v-icon>
    </button>

    <button class="login-link" @click="setPnr()">
      <small>{{ $t('dev-buttons.choose') }}</small>
      <v-icon>$sl-arrow-right</v-icon>
    </button>
  </div>
</template>

<script>
import API from '@/services/api'
import {mapActions} from 'vuex'
import Lget from 'lodash/get'
import {CompanyRoles} from '@/components/mixins'

// @group Login
// DevLogins component
export default {
  name: 'DevLogins',

  mixins: [CompanyRoles],

  data: () => ({
    fakes: [],
    filteredFakes: [],
    roles: ['', 'LÄR', 'FTGADM', 'HL', 'YUA', 'BG', 'AVDADM'],
    companies: [],
    role: '',
    company: '',
    search: '',
  }),

  watch: {
    search() {
      this.updateUsers()
    }
  },

  mounted() {
    this.getFakes()
  },

  methods: {
    ...mapActions('currentuser', ['setCurrentUser']),

    async setPnr() {
      let res = await this.$dialog.prompt({
        text: 'Ange personnummer',
        title: 'Ange önskat personnummer'
      })

      if (res) {
        this.loginAs(res)
      }
    },

    displayText(p) {
      const t = []
      try {
        if (p.apprenticeships?.length) {
          const companies = p.apprenticeships.map(element => Lget(element, 'company.name'))
          t.push(`LÄR på ${companies.join(', ')}`)
        }

        if (p.employments?.length) {
          const companies = p.employments.map(element => Lget(element, 'company.name'))
          t.push(companies.map(company => `på ${company}`).join(', '))
        }
      } catch (e) {
        console.log(e)
      }
      return t.join(';')
    },

    getFakes() {
      API.listFakeLogins().then(res => {
        this.fakes = res.data.rows
        this.getCompanies(res.data.rows)
        this.updateUsers()
      })
    },

    getCompanies(fakes) {
      this.companies = [
        '',
        ...fakes.reduce((acc, fake) => {
          if (fake.apprenticeships.length) {
            fake.apprenticeships.forEach(app => {
              if (!acc.includes(app.company.name)) {
                acc.push(app.company.name)
              }
            })
          }
          if (fake.employments.length) {
            fake.employments.forEach(emp => {
              if (!acc.includes(emp.company.name)) {
                acc.push(emp.company.name)
              }
            })
          }
          return acc
        }, [])
      ]
    },

    loginAs(pnr) {
      API.mobileBankIdLogin({
        personalNumber: pnr
      })
        .then(res => {
          this.setCurrentUser(res.data)
          this.$router.replace({ name: 'Start' })
        })
        .catch(err => {
          if (err && err.response && err.response.data) {
            this.error = err.response.data
          }
        })
    },

    updateUsers() {
      let filteredFakes = this.fakes
      if (this.role) {
        filteredFakes = filteredFakes.filter(fake => {
          if (fake.apprenticeships.length && this.role === 'LÄR') return true
          if (fake.employments.length) {
            return fake.employments.some(emp => {
              const role = this.getShortRoleDescription(emp, Lget(emp, 'company.hasDepartments'))
              return role.includes(this.role)
            })
          }
          return false
        })
      }
      if (this.company) {
        filteredFakes = filteredFakes.filter(fake => {
          if (fake.apprenticeships.length) {
            return fake.apprenticeships.some(app => {
              return this.company === Lget(app, 'company.name')
            })
          }
          if (fake.employments.length) {
            return fake.employments.some(emp => {
              return this.company === Lget(emp, 'company.name')
            })
          }
          return false
        })
      }

      if (this.search?.trim()) {
        const search = this.search.trim().toLowerCase()

        filteredFakes = filteredFakes.filter(fake => {
          const availableSearch = [
            fake?.fullName,
            ...(fake.apprenticeships?.map(a => a.company?.name) || []),
            ...(fake.employments?.map(e => e.company?.name) || [])
          ].filter(Boolean)

          return availableSearch.some(value =>
            value.trim().toLowerCase().includes(search)
          )
        })
      }

      this.filteredFakes = filteredFakes
    }
  }
}
</script>

<style lang="scss" scoped>
.test-users {
  &__list {
    max-height: 115px;
    overflow-y: auto;
    overflow-x: hidden;
    margin-bottom: 1rem;
  }
}

span.v-btn__content {
  display: table !important;
  text-align: justify;
}

.login-link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  color: #44474f;
  font-family: inherit;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.5px;
  cursor: pointer;

  &:hover {
    color: #008088;
  }

  .v-icon {
    flex-shrink: 0;
    color: #44474f !important;
    width: 14px !important;
  }

  > div {
    display: flex;
    align-items: center;
    min-width: 0;
    flex: 1;
    overflow: hidden;
    text-align: left;
    padding-right: 2rem;
  }

  small {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;

    &:first-child {
      flex-shrink: 0;
    }

    &:last-child {
      margin-left: 8px;
    }
  }
}

.border {
  border-top: 1px solid #bfc8ca;
}
</style>